import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

export enum DistributorPLPModalType {
  Discount = "discount",
  Inventory = "inventory",
}

export enum DistributorPLPModalValue {
  DiscountDetails = "discountDetails",
  NoDiscountDetails = "noDiscountDetails",
  Every15Minutes = "every15minutes",
  Hourly = "hourly",
  Daily = "daily",
  Weekly = "weekly",
  Monthly = "monthly",
  NoRecentUpdates = "noRecentUpdates",
  NotIntegratedDistributor = "notIntegratedDistributor",
}

interface DistributorPLPModalEntityParams {
  modalType: DistributorPLPModalType;
  value: DistributorPLPModalValue;
}

export class DistributorPLPModalEntity extends BaseEntityClass {
  modalType: DistributorPLPModalType;
  value: DistributorPLPModalValue;
  constructor(params: DistributorPLPModalEntityParams) {
    super();
    this.type = "distributor_plp_modal";
    this.entity_version = 2;
    this.modalType = params.modalType;
    this.value = params.value;
  }
}
